var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1135"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 144",
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FF5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18.625C15 17.9288 15.2766 17.2611 15.7688 16.7688C16.2611 16.2766 16.9288 16 17.625 16H33.375C34.0712 16 34.7389 16.2766 35.2312 16.7688C35.7234 17.2611 36 17.9288 36 18.625V34.375C36 35.0712 35.7234 35.7389 35.2312 36.2312C34.7389 36.7234 34.0712 37 33.375 37H17.625C16.9288 37 16.2611 36.7234 15.7688 36.2312C15.2766 35.7389 15 35.0712 15 34.375V18.625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopButton);
export default __webpack_public_path__ + "static/media/stopButton.35459a02df2a4cae4ddb5bc7462bb3a7.svg";
export { ForwardRef as ReactComponent };